import FinalBox from '../lib/FinalBox.class.js';
import finalBoxClose from '../lib/FinalBox/close.fn.js';
import Tabs from '../lib/Tabs.class.js';
import dispatcher from '../../_generic/dispatcher.fn.js';

FinalBox.addPlugins( finalBoxClose );

// The links
document.addEventListener('click', (e) => {

	// Popup close
	if( e.target.getAttribute('href')?.match(/^#:~:unpopup/) ){
		FinalBox.getEffectiveInstance().close();
		e.preventDefault();
	}

	// Popups open
	if( e.target.getAttribute('href')?.match(/^#:~:popup=/) ){

		let args = new URLSearchParams( e.target.getAttribute('href').replace(/^#:~:/,'') );

		let uri = args.get('popup');
		let switch_tab = args.get('switch-tab');

		let params = {
			on: {
				open_start: [( content ) => {

					if( content[0].classList.contains('tabs') )
						new Tabs(content[0], switch_tab);

				}]
			}
		}

		if( uri.indexOf('/') === 0 ){

			e.target.classList.add('pending');


			FinalBox.fromUri(
				uri,
				params,
				(r) => r.json().then((json) => {

					if( json.dispatch ){

						dispatcher( json.dispatch, e.target, uri );

					}

					e.target.classList.remove('pending');

					return json.markup;
				})
			);
		} else {
			FinalBox.fromTemplate( document.querySelector(uri), params );
		}

		e.preventDefault();
	}

	// IFrame popups
	if( e.target.getAttribute('href')?.match(/^#:~:iframe=/) ){

		let url = e.target.getAttribute('href').replace(/^#:~:iframe=/,'');
		let id = url.replace(/.*([a-f0-9]{32}).*/,'$1');

		let markup = `<iframe
			src="https://rutube.ru/play/embed/${id}/"
			allow="clipboard-write; autoplay"
			webkitAllowFullScreen mozallowfullscreen allowFullScreen
		></iframe>`;

		FinalBox.fromString(markup, {close:{button: {container:'outside'}}});

		e.preventDefault();

	}


});